module.exports = __webpack_public_path__ + "img/img_boss_banner.4cae843b.png";